import React from 'react';

import { Field, useFormikContext } from 'formik';
import PropTypes from 'prop-types';

import { maskDateInput } from '../../utils/helper-functions';

const FieldBirthday = ({
  name,
  label,
  className,
  classInvalid,
  required,
}) => {
  const { setFieldValue, values, errors, touched } = useFormikContext();
  const onChange = (event) => {
    event.preventDefault();
    maskDateInput(event, setFieldValue, name);
  };

  return (
    <div className={className}>
      <label htmlFor={name}>
        {label}
        {required && <span className="color-red">&nbsp;*</span>}
      </label>
      {errors[name] && touched[name] && <div className={classInvalid}>{errors[name]}</div>}
      {!errors[name] && touched[name] && <div className="field-valid">ok</div>}
      <Field
        name={name}
        value={values[name] || ''}
        type="text"
        placeholder="DD/MM/AAAA"
        onChange={onChange}
        maxLength="10" />
    </div>
  );
};

FieldBirthday.defaultProps = {
  required: false,
  className: 'field -input',
  classInvalid: 'field-invalid',
};

FieldBirthday.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  required: PropTypes.bool,
  classInvalid: PropTypes.string,
};

export default FieldBirthday;
